// Mirrors the extension's background filter (signupcaptions-extension
// src/background/index.js): a title is hidden before its `invisibleUntil`
// date and after its `invisibleAfter` date. Blank, missing or unparseable
// dates never hide a title. The admin stores both as ISO strings.

type VisibilityFields = {
  invisibleUntil?: string | null;
  invisibleAfter?: string | null;
};

function parse(value: string | null | undefined): number | null {
  if (!value) return null;
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? null : t;
}

export function isTitleVisible(title: VisibilityFields, now: Date = new Date()): boolean {
  const t = now.getTime();
  const until = parse(title.invisibleUntil);
  if (until !== null && t < until) return false;
  const after = parse(title.invisibleAfter);
  if (after !== null && t > after) return false;
  return true;
}

export function filterVisibleTitles<T extends VisibilityFields>(titles: T[], now: Date = new Date()): T[] {
  if (!Array.isArray(titles)) return titles;
  return titles.filter((title) => isTitleVisible(title, now));
}
